const collator = new Intl.Collator('sv-SE', { numeric: true });

/** Property types where the values already in use make useful suggestions. */
const suggestableTypes: ApiEntitySchemaProp['type'][] = [
  'string',
  'number',
  'array:string',
  'array:number',
];

export const propertyHasSuggestableValues = (
  prop: ApiEntitySchemaProp,
): boolean => suggestableTypes.includes(prop.type);

export const getDistinctPropertyValues = (
  entities: Entity[],
  prop: ApiEntitySchemaProp,
): string[] => {
  if (!propertyHasSuggestableValues(prop)) {
    return [];
  }

  const values = new Set<string>();
  entities.forEach((entity) => {
    const value: unknown = entity.properties[prop.key];
    const items: unknown[] = Array.isArray(value) ? value : [value];
    items.forEach((item) => {
      if (typeof item === 'string' && item.length > 0) {
        values.add(item);
      } else if (typeof item === 'number' && isFinite(item)) {
        values.add(item.toString());
      }
    });
  });

  return [...values].sort((a, b) => collator.compare(a, b));
};
